"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ScientificNotationNumber = _interopRequireDefault(require("./ScientificNotationNumber.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _ScientificNotationNumber["default"];
exports["default"] = _default;